// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"e785b9ed","419":"66ae4521","563":"3f00b9c4","654":"53a92adc","787":"798387e2","845":"848329ca","889":"cbeb563c"}[chunkId] + ".chunk.js";
};